import './orden_compra.css'
export { default as ListadoCompras } from "./ListadoCompras"
export { default as DetalleOrdenCompraR } from "./Detalle"
export { default as GraficaCompras } from "./Grafica";